<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      add-text="handlePermission('purchaseSupplierAdd') ? '供应商修改' : ''"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      @addNew="addNew">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker class="item" v-model="query.createTime" clearable></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>采购订单号:</label>
            <lk-input class="item" v-model.trim="query.bizCode" clearable></lk-input>
          </div>
          <div class="queryItem">
            <label>供应商:</label>
            <SupplierListSelect v-model="query.supplierId"></SupplierListSelect>
          </div>
          <div class="queryItem">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <operate-log v-model="showLog" :logList="logData"/>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import toolsService from '../../services/tools';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import OperateLog from '../../components/operateLog';
import SupplierListSelect from '../../components/SupplierListSelect.vue';

// 接口信息
export default {
  name: 'purchaseSupplier',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    OperateLog,
    SupplierListSelect,
  },
  data() {
    return {
      query: {
		    createTime: null,
        bizCode: null,
        supplierId: null,
        storeIdList: [],
      },
      showLog: false,
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        { title: '采购订单号', key: 'bizCode', minWidth: 116 },
        { title: '原供应商名称', key: 'oldSupplierName', minWidth: 116 },
        { title: '修改后供应商名称', key: 'supplierName', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTimeStr', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        // {
        //   title: '操作',
        //   key: 'action',
        //   fixed: 'right',
        //   width: 130,
        //   render: (h, { row }) => (this.hasEditable ? h('lk-button', {
        //     props: {
        //       type: 'text',
        //       disabled: row.doubtfulCount === 0,
        //     },
        //     on: {
        //       click: () => {
        //         this.handleLog(row.id);
        //       },
        //     },
        //   }, '操作日志') : null),
        // },
      ],
      tableData: [],
      logData: [],
    };
  },
  computed: {
    hasEditable() {
      return this.handlePermission('goodsPrimaryKeyOperateLog');
    },
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      toolsService.purchaseSupplierList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          list.forEach((item) => {
            // const result = {};
            // utils.exchangeTable(item, result);
            item.createTimeStr = utils.formatTime(item.createTime); // 创建时间
          });
          this.count = count;
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew() {
      this.$router.push({ name: 'purchaseSupplierAdd' });
    },
    handleLog(id) {
      this.logData = [];
      this.showLog = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.getGoodsPrimaryOperationLogList({ operateDetailId: id }).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          const logItem = {
            content: `${utils.formatTime(data.createTime)}由 ${data.createUserName} ${data.contentList.join(';')}`,
          };
          this.logData.push(logItem);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    if (!this.hasEditable) {
      this.columns.pop();
    }
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
</style>
